<template>
  <div style="display: inline;">
    <slot name="action">
      <el-button size="mini" class="btn" @click="isVisableDialog = true">{{openBtnName}}</el-button>
    </slot>
    <el-dialog
      :visible.sync="isVisableDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      @open="$emit('open-dialog')"
      @closed="$emit('closed')"
      >
      <slot name="title"></slot>
      <!-- <el-steps :active="activeStep" finish-status="success" align-center>
        <el-step class="content-step" v-for="(step, index) in stepTitles" :key="index" :title="step"></el-step>
      </el-steps> -->
      <div class="step-title" v-if="stepTitle">{{stepTitle}}</div>
      <slot></slot>
      <span slot="footer" class="dialog-footer">
        <el-button plain @click="isVisableDialog = false">取消</el-button>
        <el-button v-if="activeStep === 0 && stepTitles.length !== 0" type="primary" @click="handleResetNext">下一步</el-button>
        <el-button v-else type="primary" @click="handleResetFinish">完成</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {

  },
  props: {
    openBtnName: String,
    stepTitles: {
      type: Array,
      default() {
        return []
      }
    },
    activeStep: Number
  },
  computed: {
    stepTitle() {
      return this.stepTitles[this.activeStep]
    }
  },
  data() {
    return {
      isVisableDialog: false
    }
  },
  methods: {
    handleResetNext() {
      this.$emit('before-next')
    },
    handleResetFinish() {
      this.$emit('before-close')
    },
    handleCancel() {
      this.$emit('cancel')
    }
  },
  created() {

  }
}
</script>

<style lang="stylus" scoped>
.btn
  float: right;
  width: 65px;
  height 30px
.step-title
  text-align center
  color #ff8b00
  font-size 18px
  font-weight bold
  padding-bottom 15px
.content-step >>> .el-step__head.is-process
  color #f59a23
  border-color #f59a23
.content-step >>> .el-step__title.is-process
  font-weight 700
  color #f59a23
</style>
